export default {
    login: {
        userName: "Nom d'utilisateur",
        password: "Mot de passe",
        login: "CONNEXION",
    },
    navbar: {
        home: "Accueil",
        contracts: "Contrats",
        settings: "Paramètres",
        info: "Aide",
    },
    header: {
        home: "ACCUEIL",
        contracts: "CONTRATS",
        settings: "PARAMÈTRES",
        info: "AIDE",
        contract: "CONTRAT",
        addService: "AJOUTER UN SERVICE",
        service: "SERVICE",
    },
    home: {
        hello: "Bonjour"
    },
    contracts: {
        active: "Actifs",
        suspended: "Suspendus",
        services: "Services",
        noSuspendedContracts: "Il n'y a pas de contrats suspendus",
        noServices: "Il n'y a pas de prestataires de services en attente dans ce contrat",
        noPressupost: "Il n'y a pas de paiements en attente dans ce contrat",
        renovar: "Renouveler le contrat"
    },
    settings: {
        user: "UTILISATEUR",
        closeSession: "Fermer la session",
        settings: "PARAMÈTRES",
        appLanguage: "Langue de l'application",
        confirmationText: "Êtes-vous sûr de vouloir vous déconnecter de votre session?"
    },
    info: {

    },
    addService: {
        addTitle: "Demander un Service",
        editTitle: "Service",
        entrance: "Entrée du camping",
        exit: "Sortie du camping",
		pickupAtParking: "Récupérer la caravane au parking",
		deliveryAtParking: "Livrer la caravane au parking",
        doneText: "Fait",
        cancelText: "Annuler",
        transportDate: "Date du transport",
        camping: "Camping",
        selectCamping: "-- Sélectionner --",
        parcel: "Parcelle",
        selectParcel: "Sélectionnez la parcelle",
        save: "Enregistrer",
		payment: "Paiement",
		paymentTitle: "Paiement du service",
		servicePaymentConfirm: "Êtes-vous sûr de vouloir procéder au paiement de ce service?",
        toastMessage: "Vous devez remplir tous les champs pour enregistrer!",

        requestService: "Demander ce service",
        serviceSummary: "Résumé du service",
        total: "Total",
		paidService: "Service payé",
        transactionCompleted: "Transaction terminée correctement",
        serviceConfirm: "Êtes-vous sûr de vouloir demander ce service ?",
        loading: "Demande de service...",

        reserveNum: "Numéro de réservation",
        selectReserveNum: "Indiquez le numéro",
        availableHoursInfo: "Horaire disponible pour le transport : de {start} à {end}.",

        toastMessage2: "Pour demander un service dans les prochaines 48 heures, veuillez nous contacter."
    },
    service: {
        pending: "En Attente",
        completed: "Terminé",
        requestCompleted: "Le service a été demandé correctement"
    },
    contract: {
        entrance: "Entrée",
        exit: "Sortie",
        registration: "Inscription",
        initialDate: "Date de début",
        finalDate: "Date de fin",
        zone: "Zone",
        parkType: "Type de parking",
        pendingServices: "Services en Attente",
        completedServices: "Services terminés",
        pendingPressupost: "Paiements en attente",
        pendingPressupostS: "Paiement en attente",
        pay: "Payer",
        acceptConditions: "Accepter les termes et conditions",
        acceptConditionsTitle: "Termes et conditions",
        contractNumberRequired: "Il est nécessaire d'indiquer le numéro de réservation afin de pouvoir garantir le transport"
    },
    interceptors : {
        noAuthorized: "Utilisateur non autorisé"
    },
    payment: {
        confirmed: "Paiement confirmé",
        confirmedExtended: "Le paiement a été effectué avec succès",
        article: "Article",
        price: "Total",
        informEmail: "Vous recevrez un email avec les détails du paiement",
        goBack: "Retour",
        denied: "Paiement refusé",
        deniedExtended: "Il y a eu un problème avec le paiement",
        deniedInfo: "Veuillez réessayer dans quelques minutes, et si le problème persiste, contactez-nous"
    }
};